(function () {
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function cents(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function money(value) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents(value));
    }

    return '$' + (cents(value) / 100).toFixed(2);
  }

  function normalizeId(value) {
    return String(value || '').trim();
  }

  function getCurrentVariantId(form) {
    var input = form ? qs('[name="id"]', form) : qs('form[action^="/cart/add"] [name="id"]');
    return input ? normalizeId(input.value) : '';
  }

  function getQuantity(form) {
    var input = form ? qs('[name="quantity"]', form) : null;
    var quantity = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getProperties(form) {
    var properties = {};
    qsa('[name^="properties["]', form).forEach(function (input) {
      if (!input.name) return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      var key = input.name.replace(/^properties\[/, '').replace(/\]$/, '');
      if (!key) return;
      var value = String(input.value || '').trim();
      if (value) properties[key] = value;
    });
    return properties;
  }

  function getSkioPlanGroups(productData) {
    return (productData.selling_plan_groups || []).filter(function (group) {
      return String(group.app_id || '').toUpperCase() === 'SKIO';
    });
  }

  function getSkioPlans(productData) {
    return getSkioPlanGroups(productData).reduce(function (plans, group) {
      return plans.concat(group.selling_plans || []);
    }, []);
  }

  function readHiddenSellingPlans(root) {
    var script = root.parentNode ? qs('[data-skio-hidden-selling-plans]', root.parentNode) : null;
    if (!script) return { product: [], variants: {} };

    try {
      var data = JSON.parse(script.textContent || '{}');
      return {
        product: Array.isArray(data.product) ? data.product : [],
        variants: data.variants && typeof data.variants === 'object' ? data.variants : {}
      };
    } catch (error) {
      return { product: [], variants: {} };
    }
  }

  function addIdsToSet(values, set) {
    (Array.isArray(values) ? values : []).forEach(function (value) {
      var id = normalizeId(value);
      if (id) set[id] = true;
    });
  }

  function getHiddenPlanIds(root, variant) {
    var hiddenData = root._skioHiddenSellingPlans || { product: [], variants: {} };
    var hiddenIds = {};
    var variantId = variant && variant.id ? normalizeId(variant.id) : '';

    addIdsToSet(hiddenData.product, hiddenIds);
    if (variantId && hiddenData.variants) {
      addIdsToSet(hiddenData.variants[variantId], hiddenIds);
    }

    return hiddenIds;
  }

  function getVisibleSkioPlans(root, productData, variant) {
    var hiddenIds = getHiddenPlanIds(root, variant);
    return getSkioPlans(productData).filter(function (plan) {
      return !hiddenIds[normalizeId(plan.id)];
    });
  }

  function syncPlanOptions(root, visiblePlans, preferredPlanId) {
    var planSelect = qs('[data-skio-plan-select]', root);
    var planText = qs('[data-skio-plan-text]', root);
    if (!planSelect) return '';

    var currentPlanId = normalizeId(preferredPlanId || planSelect.value);
    var selectedPlanId = '';
    planSelect.innerHTML = '';

    visiblePlans.forEach(function (plan, index) {
      var option = document.createElement('option');
      var planId = normalizeId(plan.id);
      option.value = planId;
      option.textContent = plan.name || planId;
      planSelect.appendChild(option);

      if (!selectedPlanId && (planId === currentPlanId || (!currentPlanId && index === 0))) {
        selectedPlanId = planId;
      }
    });

    if (!selectedPlanId && visiblePlans.length) {
      selectedPlanId = normalizeId(visiblePlans[0].id);
    }

    if (selectedPlanId) {
      planSelect.value = selectedPlanId;
    }

    var selectedPlan = visiblePlans.find(function (plan) {
      return normalizeId(plan.id) === selectedPlanId;
    });
    var showDropdown = visiblePlans.length > 1;

    planSelect.hidden = !showDropdown;
    planSelect.disabled = !showDropdown;

    if (planText) {
      planText.textContent = selectedPlan ? selectedPlan.name || selectedPlanId : '';
      planText.hidden = showDropdown || !selectedPlan;
    }

    return selectedPlanId;
  }

  function getVariant(productData, variantId) {
    return (productData.variants || []).find(function (variant) {
      return normalizeId(variant.id) === normalizeId(variantId);
    }) || (productData.variants || [])[0];
  }

  function getAllocation(variant, planId) {
    return ((variant && variant.selling_plan_allocations) || []).find(function (allocation) {
      return normalizeId(allocation.selling_plan_id) === normalizeId(planId);
    });
  }

  function getDefaultPurchaseType(root) {
    return root.getAttribute('data-skio-default-purchase-type') === 'onetime' ? 'onetime' : 'subscription';
  }

  function setActive(root, type) {
    if (root.getAttribute('data-skio-disabled') === 'true') return;

    root.setAttribute('data-skio-purchase-type', type);
    qsa('[data-skio-purchase-option]', root).forEach(function (button) {
      var active = button.getAttribute('data-skio-purchase-option') === type;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var planInput = qs('[data-skio-selling-plan-input]', root);
    var planSelect = qs('[data-skio-plan-select]', root);
    if (planInput) {
      planInput.value = type === 'subscription' && planSelect ? planSelect.value : '';
    }
  }

  function setDisabled(root, disabled) {
    setVisibilityState(root, disabled, true);
  }

  function setVisibilityState(root, hidden, unavailable) {
    root.classList.toggle('is-disabled', hidden);
    root.setAttribute('data-skio-disabled', unavailable ? 'true' : 'false');
    root.hidden = hidden;

    if (unavailable) {
      root.setAttribute('aria-disabled', 'true');
    } else {
      root.removeAttribute('aria-disabled');
    }

    qsa('[data-skio-purchase-option]', root).forEach(function (button) {
      if (hidden) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
      } else {
        button.removeAttribute('aria-disabled');
        button.setAttribute('tabindex', '0');
      }
    });

    var planSelect = qs('[data-skio-plan-select]', root);
    if (planSelect) {
      planSelect.disabled = hidden || planSelect.hidden;
    }

    var planInput = qs('[data-skio-selling-plan-input]', root);
    if (planInput) planInput.disabled = hidden;
  }

  function updateDisplay(root, productData, selectedVariant) {
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var variant = selectedVariant || getVariant(productData, getCurrentVariantId(form));
    if (!variant) return;

    var planSelect = qs('[data-skio-plan-select]', root);
    var visiblePlans = getVisibleSkioPlans(root, productData, variant);
    var planId = syncPlanOptions(root, visiblePlans, planSelect ? planSelect.value : '');
    var hasVisiblePlans = visiblePlans.length > 0;
    var isUnavailable = !variant.available;
    var allocation = getAllocation(variant, planId);
    var planInput = qs('[data-skio-selling-plan-input]', root);

    var subPrice = allocation ? allocation.price : variant.price;
    var comparePrice = allocation && allocation.compare_at_price ? allocation.compare_at_price : variant.price;

    var subPriceEl = qs('[data-skio-sub-price]', root);
    var subCompareEl = qs('[data-skio-sub-compare]', root);
    var otpPriceEl = qs('[data-skio-onetime-price]', root);

    if (subPriceEl) subPriceEl.textContent = money(subPrice);
    if (subCompareEl) subCompareEl.textContent = money(comparePrice);
    if (otpPriceEl) otpPriceEl.textContent = money(variant.price);

    setVisibilityState(root, isUnavailable || !hasVisiblePlans, isUnavailable);

    if (!hasVisiblePlans) {
      if (root.getAttribute('data-skio-forced-onetime') !== 'true') {
        root.setAttribute(
          'data-skio-purchase-type-before-forced',
          root.getAttribute('data-skio-purchase-type') || getDefaultPurchaseType(root)
        );
      }
      root.setAttribute('data-skio-forced-onetime', 'true');
      setActive(root, 'onetime');
      if (planInput) planInput.value = '';
    } else if (root.getAttribute('data-skio-forced-onetime') === 'true' && !isUnavailable) {
      var purchaseTypeBeforeForced = root.getAttribute('data-skio-purchase-type-before-forced') || getDefaultPurchaseType(root);
      root.removeAttribute('data-skio-forced-onetime');
      root.removeAttribute('data-skio-purchase-type-before-forced');
      setActive(root, purchaseTypeBeforeForced);
    }

    if (planInput && root.getAttribute('data-skio-purchase-type') === 'subscription') {
      planInput.value = hasVisiblePlans ? planId : '';
    }

    var purchaseType = root.getAttribute('data-skio-purchase-type') === 'onetime' || !hasVisiblePlans ? 'onetime' : 'subscription';
    var activePrice = purchaseType === 'subscription' ? subPrice : variant.price;
    var activeCompare = purchaseType === 'subscription' ? comparePrice : variant.compare_at_price;

    document.dispatchEvent(new CustomEvent('skio-subscriptions:price-change', {
      detail: {
        formId: root.getAttribute('data-form-id'),
        productId: root.getAttribute('data-product-id'),
        purchaseType: purchaseType,
        variantId: variant.id,
        price: activePrice,
        comparePrice: activeCompare
      }
    }));
  }

  function buildItems(root, productData, form) {
    var variant = getVariant(productData, getCurrentVariantId(form));
    if (!variant) return [];
    if (!variant.available) return [];

    var visiblePlans = getVisibleSkioPlans(root, productData, variant);
    var isSubscription = root.getAttribute('data-skio-purchase-type') !== 'onetime' && visiblePlans.length > 0;
    var planInput = qs('[data-skio-selling-plan-input]', root);
    var planId = planInput ? normalizeId(planInput.value) : '';
    var productId = root.getAttribute('data-product-id');
    var planIsVisible = visiblePlans.some(function (plan) {
      return normalizeId(plan.id) === planId;
    });

    var mainItem = {
      id: Number(variant.id),
      quantity: getQuantity(form)
    };

    var properties = getProperties(form);
    if (Object.keys(properties).length) mainItem.properties = properties;
    if (isSubscription && planId && planIsVisible) mainItem.selling_plan = Number(planId);

    var items = [mainItem];
    if (!isSubscription || !planIsVisible) return items;

    qsa('[data-skio-gift]', root).forEach(function (gift) {
      var giftId = normalizeId(gift.getAttribute('data-variant-id'));
      if (!giftId || !/^\d+$/.test(giftId)) return;

      items.push({
        id: Number(giftId),
        quantity: 1,
        properties: {
          __freegift: '1',
          __product_id: productId,
          __skio_subscription_gift: '1'
        }
      });
    });

    return items;
  }

  function setLoading(form, loading) {
    var button = qs('[name="add"]', form);
    if (!button) return;

    button.classList.toggle('loading', loading);
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
    } else if (button.disabled) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }

    var spinner = qs('.loading-overlay__spinner', button) || qs('.loading-overlay__spinner', form);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  function showError(form, message) {
    var wrapper = form.closest('product-form');
    var errorWrap = wrapper ? qs('.product-form__error-message-wrapper', wrapper) : null;
    var errorText = errorWrap ? qs('.product-form__error-message', errorWrap) : null;
    if (!errorWrap || !errorText) return;

    errorText.textContent = message || '';
    errorWrap.toggleAttribute('hidden', !message);
  }

  function afterAdd() {
    if (window.updateConvertAttributes) window.updateConvertAttributes();
    if (window.jQuery && window.jQuery('.cart-summary').hasClass('enbled-custom-drawer') && typeof window.drawerOpen === 'function') {
      window.drawerOpen();
      return;
    }
    window.location.href = '/cart';
  }

  function handleAdd(event, root, productData, form) {
    if (!root.isConnected) return;
    if (root.getAttribute('data-skio-submitting') === 'true') {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    showError(form, '');

    if (root.getAttribute('data-skio-disabled') === 'true') {
      showError(form, 'This product is currently sold out.');
      return;
    }

    var items = buildItems(root, productData, form);
    if (!items.length) {
      showError(form, 'This product is currently sold out.');
      return;
    }

    root.setAttribute('data-skio-submitting', 'true');
    setLoading(form, true);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            throw new Error(json.description || json.message || 'Unable to add this item to cart.');
          }
          return json;
        });
      })
      .then(afterAdd)
      .catch(function (error) {
        showError(form, error.message);
      })
      .finally(function () {
        root.removeAttribute('data-skio-submitting');
        setLoading(form, false);
      });
  }

  function init(root) {
    var form = document.getElementById(root.getAttribute('data-form-id'));
    if (!form) return;

    root._skioHiddenSellingPlans = readHiddenSellingPlans(root);
    setActive(root, getDefaultPurchaseType(root));

    var productDataPromise = fetch('/products/' + root.getAttribute('data-product-handle') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });

    productDataPromise.then(function (productData) {
      var plans = getSkioPlans(productData);
      if (!plans.length) {
        setActive(root, 'onetime');
        return;
      }

      updateDisplay(root, productData);

      qsa('[data-skio-purchase-option]', root).forEach(function (button) {
        button.addEventListener('click', function () {
          if (root.getAttribute('data-skio-disabled') === 'true') return;
          setActive(root, button.getAttribute('data-skio-purchase-option'));
          updateDisplay(root, productData);
        });
        button.addEventListener('keydown', function (event) {
          if (root.getAttribute('data-skio-disabled') === 'true') return;
          if (event.target && event.target.closest && event.target.closest('select, input, button, a')) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          setActive(root, button.getAttribute('data-skio-purchase-option'));
          updateDisplay(root, productData);
        });
      });

      var planSelect = qs('[data-skio-plan-select]', root);
      if (planSelect) {
        planSelect.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        planSelect.addEventListener('change', function () {
          setActive(root, 'subscription');
          updateDisplay(root, productData);
        });
      }

      qsa('input, select', form).forEach(function (input) {
        input.addEventListener('change', function () {
          window.setTimeout(function () {
            updateDisplay(root, productData);
          }, 0);
        });
      });

      document.addEventListener('product-buy-box:variant-change', function (event) {
        var detail = event.detail || {};
        var sectionId = detail.sectionId;
        if (!sectionId || root.getAttribute('data-form-id') !== 'product-form-' + sectionId) return;

        window.setTimeout(function () {
          updateDisplay(root, productData, detail.variant);
        }, 0);
      });

      form.addEventListener('submit', function (event) {
        handleAdd(event, root, productData, form);
      }, true);

      var addButton = qs('[name="add"]', form);
      if (addButton) {
        addButton.setAttribute('type', 'submit');
        addButton.addEventListener('click', function (event) {
          handleAdd(event, root, productData, form);
        }, true);
      }
    }).catch(function () {
      setActive(root, 'onetime');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    qsa('[data-skio-subscriptions]').forEach(init);
  });
})();
